import * as React from "react";
import { usePromotedArticles } from "~/services/queries/zendesk.queries";
import { transformPathKebabCase } from "~/lib/utils/helper/transformPath";
import { useTranslation } from "~/lib/utils/store/useTranslation";
import { List } from "../../ui/List";

export const Featured = () => {
  const { t, i18n } = useTranslation();
  const { data, isLoading } = usePromotedArticles(i18n.language);

  return (
    <div className="flex flex-col p-5 md:p-0 gap-5">
      <h2 className="text-xl font-semibold font-title">{t("commonIssues")}</h2>
      <div>
        <List
          isLoading={isLoading}
          data={data?.map((item) => ({
            label: item.title,
            value: transformPathKebabCase(item.title, `/article/${item.id}/`),
          }))}
        />
      </div>
    </div>
  );
};
